import {React, useState} from 'react'
import {Modal,ModalBody,ModalHeader,ModalFooter, Button,Card,CardImg,CardText,CardTitle} from 'reactstrap';
import {FaPhoneAlt} from "react-icons/fa"
import Zoom from 'react-reveal/Zoom';

const Event = ({event,info,text,img,name,no,name1,no1,cost,link})=> {
  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);
    return (
      <Zoom top>
        <Card body className="bg-dark text-white">
          <CardTitle tag="h5">{event}</CardTitle>
          {(img)?(<CardImg src={img.default} alt="Card image cap" />):(null)}
          {(info)?(<CardText>{info}</CardText>):(null)}
          <Button onClick={toggle}>Learn More</Button>
          <div>
            <Modal isOpen={modal} toggle={toggle} className="bg-dark">
              <ModalHeader toggle={toggle}>{event}</ModalHeader>
                <ModalBody>{text.split('\n').map(str => <p className="my-1">{str}</p>)}
                            <br></br>
                            {(cost)?(<div><h5 className="cost">ENTRY FEE:{cost}</h5><br></br></div>):(<div><h5 className="cost">ENTRY : Free</h5><br></br></div>)}
                            {(name&&no)?(<h5>Contact</h5>):(null)}
                            {(name&&no)?(<div className="callbox">
                              <a className="btn btn-success call" href={`tel:${no}`}><FaPhoneAlt className="mr-1"></FaPhoneAlt>{name}</a>
                              <h6>{`[+91 ${no}]`}</h6>
                            </div>):(null)}
                            {(name1&&no1)?(<div className="callbox">
                              <a className="btn btn-success call" href={`tel:${no1}`}><FaPhoneAlt className="mr-1"></FaPhoneAlt>{name1}</a>
                              <h6>{`[+91 ${no1}]`}</h6>
                            </div>):(null)}
                            
                </ModalBody>
              <ModalFooter>
                {(link)?(<a className="reg-btn btn btn-success" href={link}>Register</a>):(<Button className="btn-warning" >Registrations Closed</Button>)}
                <Button color="secondary" onClick={toggle}>Ok</Button>
              </ModalFooter>
            </Modal>
          </div>
        </Card>
        </Zoom>
    )
}

export default Event;
